<template>
    <div class="page-sidebar">
        <div class="page-sidebar-box hidden-xs-only">
            <div class="page-sidebar-top clearfix">
                <Logo v-show="!isCollapse" class="fl"></Logo>
                <div class="sidebar-toggler fr">
                    <span @click="isCollapse = !isCollapse">
                        <i v-if="!isCollapse" class="el-icon-s-fold"></i>
                        <i v-else class="el-icon-s-unfold"></i>
                    </span>
                </div>
            </div>
            <el-aside style="width:auto;height: calc(100vh - 79px)">
                <page-menu :menuWidth="menuWidth" :isCollapse="isCollapse"></page-menu>
            </el-aside>
        </div>
    </div>
</template>
<script>
import PageMenu from './components/menu';
import Logo from './components/logo';
export default {
    components:{PageMenu,Logo},
    data() {
        return {
            isCollapse: false,
            menuWidth: 225
        };
    },
    watch: {
        isCollapse(flag){
            this.menuWidth = !flag ? 225 : 64;
        }
    },
    mounted() {
        const _this = this;

        const _width = window.innerWidth || document.body.clientWidth;
        if( _width < 1200 ){
            this.isCollapse = true
        }

        window.onresize = ()=>{
            const winWidth = window.innerWidth || document.body.clientWidth;
            _this.isCollapse = winWidth < 1200 ? true : false;
        }
    }
};
</script>
<style lang="scss" scoped>
.page-sidebar {
    background: #3d3d3d;
    margin-top: -42px;
    .page-sidebar-box {
        .page-sidebar-top{
            padding: 6px 16px;
            .sidebar-toggler {
                // text-align: right;
                span {
                    display: inline-block;
                    background: #242424;
                    color: $--color-font-gray;
                    // margin: 10px 16px;
                    font-size: 18px;
                    padding: 5px 7px;
                    cursor: pointer;
                }
            }
        }
        
    }
}
</style>